import type { RequestAnalyticsContext } from '@/analytics/context';
import { request } from "@umijs/max";

export async function fetchProductsByIngredient(params: any, analyticsContext?: RequestAnalyticsContext, options?: Record<string, any>) {
  return request('/data/fetch_products_by_ingredient', {
    ...options,
    method: 'POST',
    data: params,
    analyticsContext,
  });
}

export async function fetchProductsByIngredientCount(params: { countKey: string }, analyticsContext?: RequestAnalyticsContext, options?: Record<string, any>) {
  const data = params;
  return request('/data/fetch_products_by_ingredient/count', {
    ...options,
    method: 'POST',
    data,
    analyticsContext,
  });
}

export async function fetchProduct(data: any) {
  return request('/data/fetch_product', {
    method: 'POST',
    data: data,
  });
}

export async function autoCompletePackagingType(searchText: string) {
  return request(`/data/autocomplete_packaging_type/${encodeURIComponent(searchText)}`);
}

export async function autoCompleteIngredientName(params: any) {
  return request(`/data/autocomplete_ingredients/${encodeURIComponent(params)}`);
}

export async function fetchProductLists() {
  return request('/data/fetch_product_lists');
}

export async function createProductList(params: any) {
  return request('/data/create_product_list', {
    method: 'POST',
    data: params,
  });
}

export async function addProductsToList(params: any) {
  return request('/data/add_products_to_list', {
    method: 'POST',
    data: params,
  });
}

export async function fetchProductCategories() {
  return request('/data/product_categories');
}

export async function fetchFilterOptions(params?: { compact?: boolean }) {
  return request('/data/filter_options', {
    params,
  });
}

export async function autoCompleteFilterOption(filter: string, searchText: string) {
  return request(`/data/autocomplete_filter/${filter}/${encodeURIComponent(searchText)}`);
}
